import { render, staticRenderFns } from "./AvatarGroupTooltip.vue?vue&type=template&id=5870d158&"
import script from "./AvatarGroupTooltip.vue?vue&type=script&lang=js&"
export * from "./AvatarGroupTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports